import React, { lazy } from 'react';

const DesktopCCLayout = lazy(() => import(/* webpackChunkName: "desktopCCLayout" */ '../../Layouts/DesktopCCLayout'));

import { checkIfEligibleForCCV2 } from '../../services/desktopIntegration';

const CCV2ConversationPage = lazy(
  () => import(/* webpackChunkName: "ccV2" */ '../../modules/ccV2/CCV2ConversationPage')
);

const CCPage = lazy(() => import(/* webpackChunkName: "ccV1" */ '../../views/cc-mode/CCPage/CCPage'));

export const CCV2ConversationPageSwitch = React.memo(() => {
  const isEligible = checkIfEligibleForCCV2();

  if (isEligible) {
    return (
      <DesktopCCLayout>
        <CCV2ConversationPage />
      </DesktopCCLayout>
    );
  }

  return (
    <DesktopCCLayout>
      <CCPage />
    </DesktopCCLayout>
  );
});
